import React from 'react';
import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  image?: string;
}

const SEO: React.FC<SEOProps> = ({ title, description, image }) => {
  const defaultImage = "https://elektricieninarnhem026.nl/images/banner.png"; // Replace with a default image URL
  const defaultUrl = window.location.href; // Automatically set the current URL
  const defaultLogo = "/images/logo.png"; // Replace with your company's logo URL

  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: title,
    description: description,
    url: defaultUrl,
    serviceType: "Elektrische installatie",
    provider: {
      "@type": "Organization",
      name: "elektricieninarnhem026.nl",
      logo: defaultLogo,
      url: defaultUrl,
    },
    areaServed: {
      "@type": "Place",
      name: "Netherlands",
    },
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      telephone: "+31 85 212 97 78",
      areaServed: "NL",
      availableLanguage: "Dutch",
    },
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {image ? (
        <>
          <meta property="og:image" content={image} />
          <meta name="twitter:image" content={image} />
        </>
      ) : (
        <>
          <meta property="og:image" content={defaultImage} />
          <meta name="twitter:image" content={defaultImage} />
        </>
      )}
      <meta property="og:url" content={defaultUrl} />
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default SEO;
